import { useBreakpointIndex } from '@theme-ui/match-media';
import React from 'react';
import { useNavigate } from 'react-router';

import { isMobile } from 'utils/responsive';

import { IconButton } from 'components/_controls/IconButton';

const DiseaseSettingsIcon: React.FC = () => {
  const navigate = useNavigate();
  const showDiseaseSettingsIcon = !isMobile(useBreakpointIndex());

  return (
    showDiseaseSettingsIcon && (
      <IconButton
        ariaLabel="Modify diseases in the list"
        data-testid="diseaseSettingsIcon"
        icon="icon-cog"
        color="sea100"
        bold
        tooltipText="Modify the diseases in this list"
        size="medium"
        onClick={() => navigate('/settings/customsettings')}
      />
    )
  );
};
export default DiseaseSettingsIcon;
